import React from 'react'
import { Container } from '@mui/material'

import { NewNedgiaAppGuidePanel } from '../../../features/new-nedgia-apps/components'

export const NewNedgiaAppsPage = () => {
  return (
    <div>
      <Container maxWidth="lg">
        <NewNedgiaAppGuidePanel />
      </Container>
    </div>
  )
}
